import { pipe } from 'ramda';

import { IRootState } from '../../../../store/root.types';

const pathToThanksState = (state: IRootState) => state.recipient.thanks;

export const getIsLoading = pipe(pathToThanksState, state => state.isLoading);

export const getIsMessageSent = pipe(pathToThanksState, state => state.sent);

export const getIsFormLoading = pipe(pathToThanksState, state => state.isFormLoading);

export const getErrors = pipe(pathToThanksState, state => state.errors);

export const getRedeemLink = pipe(pathToThanksState, state => state.redeemLink);

export const getDelayedGiftCard = pipe(pathToThanksState, state => state.delayedGiftCard);
